import authService from './AuthService';
import { configuration } from "../authConfig";

const logController = "log";
const headers = {
    'Content-Type': 'application/json',
    'Accept': '*/*',
    'Accept-Encoding': 'gzip,deflate,br',
    'Accept-Charset': 'utf-8',
    'Accept-Language': 'en-US'
  };


export class LogService {

  
  getUrl(action, controller) {
    var serviceurl = configuration.baseUri;
    return `${serviceurl}/api/${controller}/${action}`;
  }

  async getCertificate(authorityId, requestId, instanceId, certType) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`certificate/${authorityId}/${requestId}/${instanceId}/${certType}`, logController);

    fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.blob())
      .then(blob => {
        let filename = `VaxCertificate-${authorityId}-${requestId}.pdf`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if (error !== undefined)
          console.error(error);
      });
  }

  async getRequestFile(authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`requestcommand/${authorityId}/${requestId}`, logController);

    fetch(url, {
      method: 'GET',
      headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
    })
      .then(response => response.blob())
      .then(blob => {
        let filename = `ImmucertRequest-${authorityId}-${requestId}.json`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if (error !== undefined)
          console.error(error);
      });
  }

  async getDetails(authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`details/${authorityId}/${requestId}`, logController);

    return fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  async getTestResult(authorityId, requestId, instanceId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`test/${authorityId}/${requestId}/${instanceId}`, logController);

    return fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  async getList(search) {
    console.log(`Sending post data ${JSON.stringify(search)}`)
    console.log(`Sending post data ${JSON.stringify(search)}`)

    const token = await authService.getAccessToken();
    const url = this.getUrl('list', logController);
    console.log(url);

    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(search),
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });

    if (response !== undefined) {
      const data = await response.json();
      return data;
    }

    return [];
  }

  async getRecent(authorityId, topcount) {
    console.log(`Getting recent log entries for ${authorityId} ${topcount} ${this.logController}`);

    const token = await authService.getAccessToken();
    const url = this.getUrl(`recent/${authorityId}/${topcount}`, logController);
    console.log(url);

    const response = await fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
    const data = await response.json();
    return data;
  }

  async getRequest(authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`requestentry/${authorityId}/${requestId}`, logController);

    return fetch(url, {
      method: 'GET',
      headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
    })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  async postRequest(authorityId, request, instanceId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`send/${authorityId}/${instanceId}`, logController);
    const content = {
        method: 'POST',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(JSON.parse(request))
      }

    fetch(url, content)
      .then(response => response.blob())
      .then(blob => {
        let filename = `VaxCertificate-${authorityId}.pdf`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if (error !== undefined)
          console.error(error);
      });
  }

  static get instance() { return logService }
}

const logService = new LogService();

export default logService;